



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { MethodType } from '@/templates/NewRoutes';
import { parseHrefHelper } from '@/heplers/stringHelpers';
import { currentInstance } from '@/heplers';
import GlobalBus from '@/plugins/GlobalBus';

@Component({
  filters: {
    parseHref: parseHrefHelper,
  },
  metaInfo() {
    return {
      title:
        this.$route?.meta?.fqdn === 'references' ? 'API Reference' : 'Voximplant Kit Documentation',
    };
  },
})
export default class References extends Vue {
  @Getter('getContent') data: MethodType;
  isKit: boolean = currentInstance === 'kit';
  kitLink: any = {
    href: '/kit/docs/references/kit',
    fqdn: 'references.kit',
    title: 'KIT',
    class: 'is-kit',
    imageSrc: '@/assets/images/landing/kit-references.svg',
  };
  links: any[] = [
    {
      href: '/docs/references/voxengine',
      fqdn: 'references.voxengine',
      title: 'VoxEngine',
      class: 'is-voxengine',
    },
    {
      href: '/docs/references/httpapi',
      fqdn: 'references.httpapi',
      title: 'Management API',
      class: 'is-httpapi',
    },
    {
      href: '/docs/references/websdk',
      fqdn: 'references.websdk',
      title: 'Web SDK',
      class: 'is-websdk',
    },
    {
      href: '/docs/references/androidsdk',
      fqdn: 'references.androidsdk',
      title: 'Android SDK',
      class: 'is-androidsdk',
    },
    {
      href: '/docs/references/androidsdk3',
      fqdn: 'references.androidsdk3',
      title: 'Android SDK v3',
      class: 'is-androidsdk',
      tooltip: 'This functionality is still in development process. Please use it with caution.',
    },
    {
      href: '/docs/references/iossdk',
      fqdn: 'references.iossdk',
      title: 'IOS SDK',
      class: 'is-iossdk',
    },
    {
      href: '/docs/references/reactnative',
      fqdn: 'references.reactnative',
      title: 'React Native SDK',
      class: 'is-reactnativesdk',
    },
    {
      href: '/docs/references/fluttersdk',
      fqdn: 'references.fluttersdk',
      title: 'Flutter SDK',
      class: 'is-fluttersdk',
    },
  ];
  kitLinks: any[] = [
    {
      href: 'references/kit_functions',
      title: 'Kit functions',
      class: 'is-kit-functions',
    },
    {
      href: 'references/kit_im',
      title: 'Custom channel API',
      class: 'is-kit-im',
    },
    {
      href: 'references/kit_http_api',
      title: 'HTTP API',
      class: 'is-kit-http-api',
    },
  ];

  get computeKitLink() {
    return this.isKit ? '/kit/docs/references/kit' : '/docs/references/kit';
  }

  gotoLink(linkObj: any) {
    this.$router
      .push(linkObj.href)
      .then(() => GlobalBus.emit('openLink', linkObj.fqdn.split('.')))
      .catch((error) => error);
  }
}
